module.exports = __webpack_public_path__ + "images/634c98c9f32f454cc8de6b1c73e22eda06857db6cb61a2a7e62addf457918ea9.svg";